import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import {
  authSelector,
  authStatusSelector,
} from "../../services/redux/slices/authSlice";
import Sidebar from "../../pages/common-features/Sidebar";
import { HeaderWelcome } from "../../pages/Header";
import HorizontalLinearStepper from "../../pages/common-features/HorizontalLinearStepper";
import { setActiveHorizontalIndex } from "../../services/redux/slices/stepperDynamicFormSlice";
import { RootState } from "../../services/redux/store";
import RightLayoutOutlet from "../common/RightLayoutOutlet";
import DialogStatusPopup from "../common/DialogStatusPopup";
import LoanDocumentsIcon from "../../assets/svgTabIcons/LoanDocumentsIcon";
import ProcessingFeeIcon from "../../assets/svgTabIcons/ProcessingFeeIcon";

// Responsive sidebar width based on screen size
const SIDEBAR_WIDTH = {
  xs: 0,
  sm: 80,
};

const DashboardLayoutJourny: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isAuthenticated = useSelector(authStatusSelector);
  const isBypassLogin = useSelector(
    (state: RootState) => state?.stepper?.isBypassLogin
  );
  const { userProfile } = useSelector(authSelector);
  let sidebarNavItems = [
    {
      id: "dashboard",
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <LoanDocumentsIcon color="#ffffff" />
        </svg>
      ),
      path: "/application",
      label: "Applications",
    },
  ];

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("document_verified") == "true") {
      if (isBypassLogin) {
        navigate("/application/apply-now?document_verified=true");
        dispatch(setActiveHorizontalIndex(1));
      }
    } else {
      if (isBypassLogin) {
        navigate("/application/apply-now");
        dispatch(setActiveHorizontalIndex(1));
      }
    }
  }, [isBypassLogin]);

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        background: "#f5f6fa",
        overflowX: "hidden",
      }}
    >
      {/* Sidebar - Hidden on mobile */}
      {/* {isAuthenticated && (
        <Box
          sx={{
            display: {
              xs: "none",
              sm: "block",
            },
          }}
        >
          <Sidebar navItems={sidebarNavItems} />
        </Box>
      )} */}

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          marginLeft: 0,
          padding:
            isXsOrSm && location.pathname === "/application/apply-now"
              ? "16px 8px 16px 16px"
              : isXsOrSm
                ? "16px 16px 16px 16px"
                : "16px 24px 16px 16px",
          maxWidth: "100%",
        }}
      >
        {/* {isXsOrSm && location.pathname === "/application/apply-now" ? (
          <></>
        ) : (
          <HeaderWelcome
            isAuthenticated={isAuthenticated}
            userName={userProfile?.name}
            notificationCount={2}
          />
        )} */}

        <Box sx={{ flex: 1 }}>

          <Grid
            container
            spacing={2}
            sx={{
              pt: isXsOrSm ? "80px" : 0,
            }}
          >
            <Grid
              item
              sm={12}
              sx={{ width: "100%", maxWidth: { xs: "100vw", md: "auto" } }}
            >
              <Outlet />
            </Grid>
          </Grid>

        </Box>
      </Box>

      <DialogStatusPopup />
    </Box>
  );
};

export default DashboardLayoutJourny;
